import React from 'react';

const paymentConfig = {
	settings: {
        style: 'layout1',
        layout: {
            config: {
                needUserInfo: true,
                redirectOn401: true,
                footer: {
                    display: true
                }
            }
        }
	},
	routes: [
		{
			path: '/payment-archive',
			component: React.lazy(() => import('./payment-archive'))
		},
        {
			path: '/payment-result',
			component: React.lazy(() => import('./payment-result'))
		}
	]
};


export default paymentConfig;
